export const SCROLLBAR_WIDTH_REM = 0.375;
export const SCROLLBAR_BORDER_WIDTH_REM = 0.25;
export const SCROLLBAR_ZONE_REM =
  SCROLLBAR_WIDTH_REM + SCROLLBAR_BORDER_WIDTH_REM * 2;
